module.exports = __webpack_public_path__ + "img/9788960172708.5f903e39.jpg";